'use strict';

export default class AddConfController {

  /*@ngInject*/
  constructor($http, $state, $stateParams, $scope, toaster, Upload, $parse) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$scope = $scope;
    this.toaster = toaster;
    this.Upload = Upload;
    this.$parse = $parse
    this.configForm = [
      {
        groupTitle: '',
        items: [
          {
            key: 'dpiConfig.dpi',
            label: 'DPI设置',
            enable: false,
            value: 350,
            range: [200, 640],
            type: 'number'
          },
          {
            key: 'dpiConfig.enable',
            label: 'APP原始DPI（关闭DPI配置）',
            enable: false,
            type: 'boolean',
            value: false
          },
          {
            key: 'extraConfig.allowSplashScreen',
            label: '移除启动动画',
            enable: false,
            type: 'boolean',
            value: false
          },
          {
            key: 'extraConfig.forceFullScreen',
            label: '强制全屏',
            enable: false,
            type: 'boolean',
            value: false
          },
          {
            key: 'extraConfig.fullPMAccess',
            label: '后台持续运行',
            enable: false,
            type: 'boolean',
            value: false
          },
          {
            key: 'globalActivityConfig.displayConfig.enhance',
            label: '显示增强',
            enable: false,
            type: 'boolean',
            value: false
          },
          {
            key: 'globalActivityConfig.displayConfig.ditherThreshold',
            label: '高对比度',
            enable: false,
            value: 255,
            range: [128, 255],
            type: 'boolean'
          },
          {
            key: 'globalActivityConfig.noteConfig.enable',
            label: '手写优化',
            enable: false,
            type: 'boolean',
            value: false
          },
          {
            key: 'globalActivityConfig.noteConfig.globalStrokeStyle.strokeWidth',
            label: '线宽',
            enable: false,
            value: 3,
            range: [0.5, 20],
            type: 'number'
          },
          {
            key: 'globalActivityConfig.paintConfig.antiAlisingType',
            label: '消除字体锯齿',
            enable: false,
            value: 0,
            range: [0, 100],
            type: 'number'
          },
          {
            key: 'globalActivityConfig.paintConfig.fillContrast',
            label: '背景颜色',
            enable: false,
            value: 1,
            range: [0, 255],
            type: 'number'
          },
          {
            key: 'globalActivityConfig.paintConfig.iconContrast',
            label: '图标颜色',
            enable: false,
            value: 1,
            range: [0, 255],
            type: 'number'
          },
          {
            key: 'globalActivityConfig.paintConfig.imgEAC',
            label: '封面颜色',
            enable: false,
            type: 'boolean',
            value: false
          },
          {
            key: 'globalActivityConfig.paintConfig.textBold',
            label: '标题字体加粗',
            enable: false,
            type: 'boolean',
            value: false
          },
          {
            key: 'globalActivityConfig.paintConfig.textEACType',
            label: '文字描边',
            enable: false,
            value: 0,
            range: [0, 3],
            type: 'number'
          },
          {
            key: 'globalActivityConfig.refreshConfig.animationDuration',
            label: '动画过滤时间',
            enable: false,
            value: 50,
            range: [0, 3000],
            type: 'number'
          },
          {
            key: 'globalActivityConfig.refreshConfig.antiFlicker',
            label: '防闪烁',
            enable: false,
            value: 10,
            range: [0, 32],
            type: 'number'
          },
          {
            key: 'globalActivityConfig.refreshConfig.gcInterval',
            label: '按点击次数全刷',
            enable: false,
            value: 20,
            range: [0, 50],
            type: 'number'
          },
          {
            key: 'globalActivityConfig.refreshConfig.useGCForNewSurface',
            label: '页面切换时全刷',
            enable: false,
            type: 'boolean',
            value: false
          },
          {
            key: 'globalCSSConfig.fontBold',
            label: '网页文字加粗',
            enable: false,
            type: 'boolean',
            value: false
          },
          {
            key: 'globalCSSConfig.fontColor',
            label: '网页文字颜色',
            enable: false,
            value: 0,
            range: [0, 255],
            type: 'number'
          },
          {
            key: 'globalCSSConfig.fontSize',
            label: '网页字号',
            enable: false,
            value: 100,
            range: [100, 120],
            type: 'number'
          },
          {
            key: 'keyboardConfig.pageKeyMode',
            label: '侧键定义',
            enable: false,
            value: '',
            range: [
              {
                label: "翻页",
                value: 0
              },
              {
                label: "音量",
                value: 1
              },
              {
                label: "滚屏手势",
                value: 2
              }
            ],
            type: 'select'
          },
          {
            key: 'rotationConfig.enable',
            label: '强制旋转',
            enable: false,
            type: 'boolean',
            value: false
          },
          {
            key: 'scrollArgs.endYPercent',
            label: '结束位置',
            enable: false,
            value: 0.8,
            range: [0, 100],
            type: 'number'
          },
          {
            key: 'scrollArgs.startYPercent',
            label: '起始位置',
            enable: false,
            value: 0.2,
            range: [0, 100],
            type: 'number'
          },
          {
            key: 'globalActivityConfig.displayConfig.contrast',
            label: '深色增强',
            enable: false,
            type: 'number'
          },
          {
            key: 'globalActivityConfig.displayConfig.monoLevel',
            flag: 'black_white_screen',
            label: '浅色过滤',
            enable: false,
            type: 'number'
          },
          {
            key: 'globalActivityConfig.displayConfig.cfaColorBrightness',
            flag: 'color_screen',
            label: '色彩亮度',
            enable: false,
            type: 'number'
          },
          {
            key: 'globalActivityConfig.displayConfig.cfaColorSaturation',
            flag: 'color_screen',
            label: '鲜艳度增强',
            enable: false,
            type: 'number'
          },
          // {
          //   key: 'currentColorType',
          //   label: '色彩模式（黑白）',
          //   enable: false,
          //   flag: 'black_white_screen',
          //   value: '',
          //   range: [
          //     {
          //       label: "标准预设",
          //       value: 'eac_color_type_1',
          //       associationAttributes: [
          //         {
          //           type: 'default',
          //           attr:[
          //             {
          //               key: 'globalActivityConfig.displayConfig.monoLevel',
          //               label: '浅色过滤',
          //               value: 10,
          //               type: 'number'
          //             },
          //             {
          //               key: 'globalActivityConfig.displayConfig.contrast',
          //               label: '深色增强',
          //               value: 80,
          //               type: 'number'
          //             }
          //           ],
          //           data: {
          //             appConfig: {
          //               globalActivityConfig: {
          //                 displayConfig: {
          //                   contrast: 80,
          //                   monoLevel: 10
          //                 }
          //               }
          //             }
          //           }
          //         }
          //       ]
          //     },
          //     {
          //       label: "浓墨预设",
          //       value: 'eac_color_type_2',
          //       associationAttributes: [
          //         {
          //           type: 'default',
          //           attr:[
          //             {
          //               key: 'globalActivityConfig.displayConfig.monoLevel',
          //               label: '浅色过滤',
          //               value: 10,
          //               type: 'number'
          //             },
          //             {
          //               key: 'globalActivityConfig.displayConfig.contrast',
          //               label: '深色增强',
          //               value: 80,
          //               type: 'number'
          //             }
          //           ],
          //           data: {
          //             appConfig: {
          //               globalActivityConfig: {
          //                 displayConfig: {
          //                   contrast: 80,
          //                   monoLevel: 10
          //                 }
          //               }
          //             }
          //           }
          //         }
          //       ]
          //     },
          //     {
          //       label: "自定义",
          //       value: 'eac_color_type_3',
          //       associationAttributes: [
          //         {
          //           type: 'custom',
          //           attr:[
          //             {
          //               key: 'globalActivityConfig.displayConfig.monoLevel',
          //               label: '浅色过滤',
          //               value: 0,
          //               type: 'number'
          //             },
          //             {
          //               key: 'globalActivityConfig.displayConfig.contrast',
          //               label: '深色增强',
          //               value: 0,
          //               type: 'number'
          //             }
          //           ],
          //           data: {
          //             appConfig: {
          //               globalActivityConfig: {
          //                 displayConfig: {
          //                   contrast: 0,
          //                   monoLevel: 0
          //                 }
          //               }
          //             }
          //           }
          //         }
          //       ]
          //     }
          //   ],
          //   type: 'select'
          // },
          // {
          //   key: 'currentColorType',
          //   label: '色彩模式（彩屏）',
          //   enable: false,
          //   value: '',
          //   flag: 'color_screen',
          //   range: [
          //     {
          //       label: "均衡预设",
          //       value: 'eac_color_type_1',
          //       associationAttributes: [
          //         {
          //           type: 'default',
          //           attr:[
          //             {
          //               key: 'globalActivityConfig.displayConfig.cfaColorBrightness',
          //               label: '色彩亮度',
          //               value: 0,
          //               type: 'number'
          //             },
          //             {
          //               key: 'globalActivityConfig.displayConfig.cfaColorSaturation',
          //               label: '鲜艳度增强',
          //               value: 0,
          //               type: 'number'
          //             },
          //             {
          //               key: 'globalActivityConfig.displayConfig.contrast',
          //               label: '深色增强',
          //               value: 30,
          //               type: 'number'
          //             }
          //           ],
          //           data: {
          //             appConfig: {
          //               globalActivityConfig: {
          //                 displayConfig: {
          //                   cfaColorBrightness: 0,
          //                   cfaColorSaturation: 0,
          //                   contrast: 30
          //                 }
          //               }
          //             }
          //           }
          //         }
          //       ]
          //     },
          //     {
          //       label: "鲜艳预设",
          //       value: 'eac_color_type_2',
          //       associationAttributes: [
          //         {
          //           type: 'default',
          //           attr:[
          //             {
          //               key: 'globalActivityConfig.displayConfig.cfaColorBrightness',
          //               label: '色彩亮度',
          //               value: 0,
          //               type: 'number'
          //             },
          //             {
          //               key: 'globalActivityConfig.displayConfig.cfaColorSaturation',
          //               label: '鲜艳度增强',
          //               value: 50,
          //               type: 'number'
          //             },
          //             {
          //               key: 'globalActivityConfig.displayConfig.contrast',
          //               label: '深色增强',
          //               value: 30,
          //               type: 'number'
          //             }
          //           ],
          //           data: {
          //             appConfig: {
          //               globalActivityConfig: {
          //                 displayConfig: {
          //                   cfaColorBrightness: 0,
          //                   cfaColorSaturation: 50,
          //                   contrast: 30
          //                 }
          //               }
          //             }
          //           }
          //         }
          //       ]
          //     },
          //     {
          //       label: "自定义",
          //       value: 'eac_color_type_3',
          //       associationAttributes: [
          //         {
          //           type: 'custom',
          //           attr:[
          //             {
          //               key: 'globalActivityConfig.displayConfig.cfaColorBrightness',
          //               label: '色彩亮度',
          //               value: 0,
          //               type: 'number'
          //             },
          //             {
          //               key: 'globalActivityConfig.displayConfig.cfaColorSaturation',
          //               label: '鲜艳度增强',
          //               value: 0,
          //               type: 'number'
          //             },
          //             {
          //               key: 'globalActivityConfig.displayConfig.contrast',
          //               label: '深色增强',
          //               value: 0,
          //               type: 'number'
          //             }
          //           ],
          //           data: {
          //             appConfig: {
          //               globalActivityConfig: {
          //                 displayConfig: {
          //                   cfaColorBrightness: 0,
          //                   cfaColorSaturation: 0,
          //                   contrast: 0
          //                 }
          //               }
          //             }
          //           }
          //         }
          //       ]
          //     }
          //   ],
          //   type: 'select'
          // },
          {
            key: 'globalActivityConfig.refreshConfig.refreshModeIndex',
            label: '刷新模式',
            enable: false,
            value: '',
            range: [
              {
                label: "净清",
                value: 'refresh_mode_1'
              },
              {
                label: "标准",
                value: 'refresh_mode_2'
              },
              {
                label: "极速",
                value: 'refresh_mode_3'
              }
            ],
            type: 'select'
          },
        ] 
      }
    ],
    this.specialConfig = {
      updateModePad: {
        '1': {
          "turbo": 0,
          "updateMode": 0
        },
        '2': {
          "turbo": 2,
          "updateMode": 2
        },
        '3': {
          "turbo": 4,
          "updateMode": 2
        },
        '4': {
          "turbo": 5,
          "updateMode": 2
        },
        '5': {
          "turbo": 0,
          "updateMode": 3
        }
      },
      updateModePadEink: {
        '1': {
          "turbo": 0,
          "updateMode": 0
        },
        '2': {
          "turbo": 0,
          "updateMode": 2
        },
        '3': {
          "turbo": 2,
          "updateMode": 2
        },
        '4': {
          "turbo": 3,
          "updateMode": 2
        },
        '5': {
          "turbo": 0,
          "updateMode": 3
        }
      },
      updateModePhone: {
        '1': {
          "turbo": 0,
          "updateMode": 0
        },
        '2': {
          "turbo": 0,
          "updateMode": 2
        },
        '3': {
          "turbo": 1,
          "updateMode": 2
        },
        '4': {
          "turbo": 2,
          "updateMode": 2
        },
        '5': {
          "turbo": 0,
          "updateMode": 3
        }
      },
      updateModeEink: {
        '1': {
          updateMode: 0
        },
        '2': {
          updateMode: 3
        },
        '3': {
          updateMode: 2
        },
        '4': {
          updateMode: 1
        },
        '5': {
          updateMode: 4
        }
      }
    }
    this.tmpConf = null
    this.isRepeat = false
    this.existConfs = null
    this.newAppConfig = {}
    this.appConfig = {}


    this.flags = [
      {
        label: '彩屏',
        value:'color_screen',
      },
      {
        label: '黑白屏',
        value:'black_white_screen',
      },
      {
        label: '手机',
        value: 'phone',
      },
      {
        label: '平板',
        value:'pad',
      },
    ]

  }

  $onInit() {
    this.getConf(this.$stateParams.id);
    this.getList();

    this.$scope.$watch('acEditCtrl.file', (file) => {
      if (file !== undefined && file !== null) {
        this.uploadIcon(file);
      }
    });

    this.$scope.$watchCollection('acEditCtrl.newAppConfig', (newVal, oldVal) => {
      this.updateAppConfig()
    })
  }

  transformConfigArray(configArray) {
    const transformedObject = {};

    configArray.forEach(config => {
        if (!config.enable) {
          return
        }
        const keys = config.key.split('.');
        let currentLevel = transformedObject;

        for (let i = 0; i < keys.length; i++) {
            if (i === keys.length - 1) {
                if (this.specialConfig[keys[i]] && this.specialConfig[keys[i]][config.value]) {
                  const tmpObj = this.specialConfig[keys[i]][config.value]
                  for (const key in tmpObj) {
                    currentLevel[key] = tmpObj[key];  
                  }
                  currentLevel['rename'] = keys[i]
                } else {
                  currentLevel[keys[i]] = config.value;
                }
            } else {
                currentLevel[keys[i]] = currentLevel[keys[i]] || {};
                currentLevel = currentLevel[keys[i]];
            }
        }
    });

    return transformedObject;
  }

  updateConfigArray(configArray, nestedObject) {
    this.appConfig = nestedObject
    for (const item of configArray) {
      const val = this.getNestedProperty(item.key)
      if (val) {
        item.enable = true
      }
    }

    return configArray;
}

  updateConfigArray1(configArray, nestedObject) {
    const findValue = (keys, obj) => {
        return keys.reduce((o, k) => (o && o[k] !== undefined) ? o[k] : undefined, obj);
    };

    const findSpecialValue = (keys, obj) => {
      const renameKeys = [...keys]
      renameKeys[renameKeys.length - 1] = 'rename'
      const exist = findValue(renameKeys, obj)
      if (!exist || exist !== keys[keys.length - 1]) {
        return undefined
      }
      const specialConfig = this.specialConfig[keys[keys.length -1]]
      const subKeys = Object.keys(Object.values(specialConfig)[0])
      let tmpObj = {}
      for (const key of subKeys) {
        const tmpKeys = [...keys]
        tmpKeys[tmpKeys.length - 1] = key
        const value = findValue(tmpKeys, obj)
        tmpObj[key] = value
      }
      
      let res
      for (const key of Object.keys(specialConfig)) {
        if (_.isEqual(specialConfig[key], tmpObj)) {
          res = key
          break
        }
      }
      return res
    }

    configArray.forEach(config => {
        const keys = config.key.split('.');
        let value
        if (this.specialConfig[keys[keys.length -1]]) {
          value = findSpecialValue(keys, nestedObject)
        } else {
          value = findValue(keys, nestedObject);
        }
        // config.value = value
        if (value !== undefined) {
          config.enable = true
        }
    });

    return configArray;
}

  updateConfigData() {
    let obj = {}
    for (const group of this.configForm) {
      const res = this.transformConfigArray(group.items)
      obj = Object.assign(obj, res)
    }
    if (JSON.stringify(obj) !== this.conf.config) {
      this.conf.config = JSON.stringify(obj)
    }
  }

  loadDefaultValue() {
    if(!this.conf.config) {
      return
    }

    const config = JSON.parse(this.conf.config)
    for (const group of this.configForm) {
      group.items = this.updateConfigArray(group.items, config)
    }

    this.initNewAppConfig()
  }

  initNewAppConfig() {
    this.newAppConfig = {}

    this.appConfig = JSON.parse(this.conf.config)
    for (const group of this.configForm) {
      for (const item of group.items) {
        if (item.enable) {
          this.newAppConfig[item.key] = this.getNestedProperty(item.key)
        }   
      }
    }
  }


  getConf(id) {
    this.$http.get('/api/AppConfs/' + id).then(response => {
      this.conf = response.data;
      this.conf.groups = this.conf.groups.map(item => item._id);//用于初始化选中功能；
      this.loadDefaultValue()

      if (this.conf.code) {
        this.getTmpConf()
      }
    });
  }

  save() {
    // this.updateConfigData()
    this.$http.put(`api/AppConfs/${this.$stateParams.id}`, this.conf).then(response => {
      // this.$state.go('appconfs.show', {
      //   id: this.$stateParams.id
      // });
      if (this.conf.code) {
        this.$state.go('codeappconfs')
      } else {
        this.$state.go('appconfs');
      }
    });
  }


  uploadIcon(file) {
    this.toaster.pop({
      type: 'wait',
      title: '正在上传图标，请稍等...',
      body: file.name,
      timeout: 3000 * 1000
    });

    file.upload = this.Upload.upload({
      url: `/api/AppConfs/${this.conf._id}/uploadIcon`,
      file: file,
      data: this.conf,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    file.upload.progress((evt) => {
      file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
    });

    file.upload.success((data, status, headers, config) => {
      this.toaster.clear();
      this.getConf(this.$stateParams.id);
      this.toaster.pop('success', '上传成功', file.name);
    });

    file.upload.error((err) => {
      this.toaster.clear();
      this.toaster.pop('error', '上传失败', JSON.stringify(err));
    });
  }

  getList() {
    this.$http.get('/api/AppConfGroups').then(res => {
      this.groups = res.data;
    });
  }

  toggleSelection(id) {
    let idx = this.conf.groups.indexOf(id);
    if(idx > -1) {
      this.conf.groups.splice(idx, 1);
    } else {
      this.conf.groups.push(id);
    }
  }

  toggleFlagsSelection(val) {
    if (!this.conf.flags) {
      this.conf.flags = []
    }
    let flags = this.conf.flags.indexOf(val);
    if(flags > -1) {
      this.conf.flags.splice(flags, 1);
    } else {
      this.conf.flags.push(val);
    }
  }

  getConfByCode() {
    const code = this.conf.code
    if (code.length !== 4) {
      return
    }

    const params = {
      code
    }

    this.$http.get('/api/AppConfs/getConfByCode', { params }).then(response => {
      this.tmpConf = response.data;
    }).catch(err => {
      console.log(err)
      this.tmpConf = null
    });
  }

  checkRecommendedBy() {
    const pkg = this.conf.pkg
    const recommendedBy = this.conf.recommendedBy

    const params = {
      pkg,
      recommendedBy
    }

    this.$http.get('/api/AppConfs/checkRecommendedBy', { params }).then(response => {
      const tmpConf = response.data
      if (tmpConf.code !== this.conf.code && tmpConf.pkg === this.conf.pkg && tmpConf.recommendedBy === this.conf.recommendedBy) {
        this.isRepeat = true
      }
    }).catch(err => {
      console.log(err)
      this.isRepeat = false
    });
  }

  getTmpConf() {
    const code = this.conf.code
    const pkg = this.conf.pkg
    const recommendedBy = this.conf.recommendedBy

    const params = {
      
    }

    if (code.length === 4) {
      params.code = code
    }

    if (pkg && recommendedBy) {
      params.pkg = pkg
      params.recommendedBy = recommendedBy
    }

    if (Object.keys(params).length === 0) {
      return
    }

    this.$http.post('/api/AppConfs/getConf', params).then(response => {
      this.checkRecommendedByRepeat(response.data)
    }).catch(err => {
      console.log(err)
      this.tmpConf = null
    });
  }

  checkRecommendedByRepeat(conf) {
    const confByCode = conf.findByCode
    const confByRecommend = conf.findByRecommend

    if (confByCode && confByCode.length) {
      this.existConfs = confByCode.filter(item => item.pkg != this.conf.pkg).map(item => item.name).join(',')
    }

    if (confByRecommend && confByRecommend.code !== this.conf.code && confByRecommend.pkg === this.conf.pkg && confByRecommend.recommendedBy === this.conf.recommendedBy) {
      this.isRepeat = true
    } else {
      this.isRepeat = false
    }

  }


  updateDefaultConfigData(data, checked) {
    if (!checked) {
      delete this.newAppConfig[data.key]
    } else {
      if (data.value !== '' || data.value !== undefined) {
        this.newAppConfig[data.key] = data.value 
      }
    }
    this.updateAppConfig()
  }

  updateAppConfig() {
    if (!this.conf) {
      return
    }
    this.appConfig = {}
    for(var key in this.newAppConfig) {
      this.setNestedProperty(key, this.newAppConfig[key]);
    }
    if (Object.keys(this.appConfig).length) {
      this.conf.config = JSON.stringify(this.appConfig, null, 4)
    } else {
      this.conf.config = ''
    }
  }

  setNestedProperty(path, value) {
    var setter = this.$parse(path).assign;
    
    if (angular.isFunction(setter)) {
      this.ensurePathExists(this.appConfig, path);
      
      setter(this.appConfig, value);
    } else {
      console.error("不能设置嵌套属性：", path);
    }
  };

  getNestedProperty(path) {
    var getter = this.$parse(path)
    try {
      return getter(this.appConfig)
    } catch (error) {
      this.setNestedProperty(path, undefined)
      return undefined
    }
  }

  ensurePathExists(obj, path) {
    var parts = path.split('.');
    var current = obj;
    
    for (var i = 0; i < parts.length - 1; i++) {
      var part = parts[i];
      
      // 如果当前层级不存在，则创建新对象
      if (current[part] === undefined || current[part] === null) {
        current[part] = {};
      }
      
      // 向下移动到下一层级
      current = current[part];
    }
  }

  selectedItem(key, data) {
    const item = data.range.find(a => a.value === key)
    if (!item) {
      return
    }
    if (item.associationAttributes) {
      for (const attrItem of item.associationAttributes) {
        for (const a of attrItem.attr) {
          this.newAppConfig[a.key] = a.value
        }
      }
    }
    return item
  }
}



// WEBPACK FOOTER //
// ./client/app/appconfs/edit/edit.controller.js